document.addEventListener('DOMContentLoaded', function() {
  initProductCardGalleries();

  // Debounced window-resize handler: recompute every gallery's pixel
  // height so card heights stay aligned across the grid at any viewport.
  let resizeRaf = null;
  window.addEventListener('resize', () => {
    if (resizeRaf) return;
    resizeRaf = requestAnimationFrame(() => {
      resizeRaf = null;
      document.querySelectorAll('.product-card-swiper-container').forEach(c => forceFillStyles(c));
    });
  });
});

function initProductCardGalleries() {
  // Add CSS for the swiper first to minimize FOUC (Flash of Unstyled Content)
  addSwiperStyles();
  
  // Find all product card swipers that were created in Liquid
  const productCardSwipers = document.querySelectorAll('.product-card-swiper-container');
  
  productCardSwipers.forEach(swiperContainer => {
    // Get the product URL from a data attribute
    const productUrl = swiperContainer.getAttribute('data-product-url');
    
    // Create a wrapper anchor element for right-click functionality
    wrapSwiperInAnchor(swiperContainer, productUrl);
    
    // Initialize Swiper for each container
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      autoHeight: false,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: swiperContainer.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: swiperContainer.querySelector('.swiper-button-next'),
        prevEl: swiperContainer.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        // Mobile view (show pagination, hide arrows)
        320: {
          navigation: {
            enabled: false,
          },
          pagination: {
            enabled: true,
          }
        },
        // Desktop view (show arrows, hide pagination)
        768: {
          navigation: {
            enabled: true,
          },
          pagination: {
            enabled: false,
          }
        }
      },
      on: {
        init: function() {
          const navElements = swiperContainer.querySelectorAll('.swiper-button-prev, .swiper-button-next, .swiper-pagination');
          navElements.forEach(el => {
            el.removeAttribute('style');
            el.classList.add('swiper-nav-initialized');
          });
          forceFillStyles(swiperContainer);
        },
        imagesReady: function() {
          forceFillStyles(swiperContainer);
        },
        slideChange: function() {
          forceFillStyles(swiperContainer);
        },
        resize: function() {
          forceFillStyles(swiperContainer);
        },
        update: function() {
          forceFillStyles(swiperContainer);
        }
      }
    });

    // Prevent navigation when clicking on swiper controls
    preventNavigationOnControls(swiperContainer);

    // Keep the fill styles applied even when Swiper rewrites inline
    // styles during its own post-init / loop-cloning / resize passes.
    observeAndKeepFilled(swiperContainer);
  });
}

function observeAndKeepFilled(swiperContainer) {
  if (!swiperContainer || swiperContainer.__fillObserver) return;

  let rafId = null;
  const reapply = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      observer.disconnect();
      forceFillStyles(swiperContainer);
      observer.observe(swiperContainer, observerConfig);
    });
  };

  const observerConfig = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
  };
  const observer = new MutationObserver(reapply);

  forceFillStyles(swiperContainer);
  observer.observe(swiperContainer, observerConfig);
  swiperContainer.__fillObserver = observer;

  // Also re-apply a few times during the first second to catch any async
  // work Swiper or its image loader does after init.
  [50, 150, 400, 800, 1500].forEach(ms => setTimeout(reapply, ms));
}

// Aspect ratio of the product card media container (height / width).
// Matches the historical hardcoded `--ratio-percent: 145%` in card-product.liquid.
const PRODUCT_CARD_RATIO = 1.45;

function forceFillStyles(swiperContainer) {
  if (!swiperContainer) return;

  // Lock the outer card media container to a deterministic pixel height
  // so Swiper's init/clone/resize passes can't collapse it.
  const cardInner = swiperContainer.closest('.card__inner');
  const cardMedia = swiperContainer.closest('.card__media');
  if (cardInner) {
    const w = cardInner.getBoundingClientRect().width;
    if (w > 0) {
      const h = Math.round(w * PRODUCT_CARD_RATIO);
      cardInner.style.setProperty('height', h + 'px', 'important');
      cardInner.style.setProperty('min-height', h + 'px', 'important');
    }
  }
  if (cardMedia) {
    cardMedia.style.setProperty('height', '100%', 'important');
  }

  // The anchor wrapper added by wrapSwiperInAnchor sits between .card__media
  // and the swiper container. Without an explicit height:100% it shrinks to
  // the image's intrinsic height, creating a visible grey gap.
  const anchor = swiperContainer.parentElement;
  if (anchor && anchor.tagName === 'A') {
    anchor.style.setProperty('height', '100%', 'important');
    anchor.style.setProperty('width', '100%', 'important');
    anchor.style.setProperty('display', 'block', 'important');
  }

  const wrapper = swiperContainer.querySelector('.swiper-wrapper');
  if (wrapper) {
    wrapper.style.setProperty('height', '100%', 'important');
    wrapper.style.setProperty('width', '100%', 'important');
  }
  swiperContainer.style.setProperty('height', '100%', 'important');
  swiperContainer.style.setProperty('width', '100%', 'important');

  swiperContainer.querySelectorAll('.swiper-slide').forEach(slide => {
    slide.style.setProperty('height', '100%', 'important');
  });
  swiperContainer.querySelectorAll('img').forEach(img => {
    img.style.setProperty('width', '100%', 'important');
    img.style.setProperty('height', '100%', 'important');
    img.style.setProperty('object-fit', 'cover', 'important');
    img.style.setProperty('object-position', 'center center', 'important');
    img.style.setProperty('display', 'block', 'important');
  });
}

function wrapSwiperInAnchor(swiperContainer, productUrl) {
  // Only proceed if we have a valid product URL and the container isn't already wrapped
  if (!productUrl || swiperContainer.parentElement.tagName === 'A') return;
  
  // Create the anchor element
  const anchor = document.createElement('a');
  anchor.href = productUrl;
  anchor.classList.add('product-card-link');
  anchor.style.display = 'block';
  anchor.style.textDecoration = 'none';
  anchor.style.color = 'inherit';
  anchor.style.setProperty('height', '100%', 'important');
  anchor.style.setProperty('width', '100%', 'important');
  
  // Insert the anchor before the swiper container
  swiperContainer.parentNode.insertBefore(anchor, swiperContainer);
  
  // Move the swiper container inside the anchor
  anchor.appendChild(swiperContainer);
}

function preventNavigationOnControls(swiperContainer) {
  // Prevent anchor navigation when clicking on navigation controls
  const controls = swiperContainer.querySelectorAll('.swiper-button-prev, .swiper-button-next, .swiper-pagination');
  
  controls.forEach(control => {
    control.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
    });
  });
}

function addSwiperStyles() {
  // Check if styles are already added
  if (document.getElementById('product-card-swiper-styles')) return;
  
  const styleSheet = document.createElement('style');
  styleSheet.id = 'product-card-swiper-styles';
  styleSheet.innerHTML = `
    .card__media a.product-card-link {
      display: block !important;
      width: 100% !important;
      height: 100% !important;
    }

    .product-card-swiper-container {
      position: relative;
      width: 100% !important;
      height: 100% !important;
      overflow: hidden;
    }

    .product-card-swiper-container .swiper-wrapper {
      width: 100% !important;
      height: 100% !important;
    }

    .product-card-swiper-container .swiper-slide {
      display: flex !important;
      align-items: stretch !important;
      justify-content: center;
      height: 100% !important;
      width: 100% !important;
    }

    .product-card-swiper-container .swiper-slide img,
    .product-card-swiper-container img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      object-position: center center !important;
      display: block;
    }
    
    /* Hide navigation elements by default */
    .product-card-swiper-container .swiper-button-prev,
    .product-card-swiper-container .swiper-button-next,
    .product-card-swiper-container .swiper-pagination {
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease;
      z-index: 20; /* Ensure they're above the anchor */
    }
    
    /* Show navigation elements after initialization */
    .product-card-swiper-container .swiper-nav-initialized {
      visibility: visible;
      opacity: 0; /* Still hidden but now can transition to visible */
    }
    
    .product-card-swiper-container .swiper-button-prev,
    .product-card-swiper-container .swiper-button-next {
      color: var(--color-foreground);
      width: 30px;
      height: 30px;
      z-index: 20; /* Ensure buttons are above slides and anchor */
    }
    
    .product-card-swiper-container .swiper-button-prev:after,
    .product-card-swiper-container .swiper-button-next:after {
      display: none;
    }
    
    .product-card-swiper-container:hover .swiper-button-prev.swiper-nav-initialized,
    .product-card-swiper-container:hover .swiper-button-next.swiper-nav-initialized {
      opacity: 0.8;
    }
    
    .product-card-swiper-container .swiper-pagination {
      position: absolute;
      bottom: 5px;
      z-index: 20; /* Ensure pagination is above slides and anchor */
    }
    
    .product-card-swiper-container .swiper-pagination.swiper-nav-initialized {
      opacity: 1;
    }
    
    .product-card-swiper-container .swiper-pagination-bullet {
      background: var(--color-foreground);
      opacity: 0.5;
    }
    
    .product-card-swiper-container .swiper-pagination-bullet-active {
      opacity: 1;
    }
    
    @media screen and (max-width: 767px) {
      .product-card-swiper-container .swiper-button-prev,
      .product-card-swiper-container .swiper-button-next {
        display: none;
      }
    }
    
    @media screen and (min-width: 768px) {
      .product-card-swiper-container .swiper-pagination {
        display: none;
      }
    }
  `;
  
  document.head.appendChild(styleSheet);
}
